<div class="page_layout">
  <div class="page_layout__container">
    <div class="page_layout__container__header">Menu Items Order</div>
    <div class="page_layout__container__body">
      <div class="page_layout__container__body__drop">
        <app-dropdown-admin
          class="dropdowncategories"
          [input_dropdown_title]="'Select Category'"
          [input_dropdown_options]="categories"
          (selectedId)="onCategorySelect($event)"
        />
      </div>
      <div class="page_layout__container__body__CategoryName">
        {{ selectedCategory?.nameEn }}
      </div>

      <div
        class="page_layout__container__body__ListContainer"
        cdkDropList
        (cdkDropListDropped)="drop($event)"
      >
        @for (item of Items; track item) {
        <div
          class="page_layout__container__body__ListContainer__item-box"
          cdkDrag
        >
          {{ item.nameEn }}
        </div>
        }
      </div>
    </div>
  </div>
</div>
<app-admin-success-message> </app-admin-success-message>
